"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentCompleteWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var journey_model_1 = require("@athena-portal/journey-model");
var PaymentCompleteWidget = exports.PaymentCompleteWidget = /** @class */ (function (_super) {
    __extends(PaymentCompleteWidget, _super);
    function PaymentCompleteWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaymentCompleteWidget.prototype.render = function () {
        return (React.createElement("div", { className: "panel" },
            React.createElement("img", { className: "purchase-success-icon d-block mx-auto mb-4", src: "/img/check-mark-big.svg", alt: "Payment complete picture", "aria-label": "Payment complete picture", tabIndex: 0 }),
            React.createElement("h1", { className: "text-center text-blue-2" }, this.wordingToShow()),
            React.createElement("p", { className: "text-center mb-2" }, "Thanks for choosing Allianz \u2013 you're now ready to roll!"),
            React.createElement("p", { id: "subscriptionNumber", className: "d-none" }, this.props.interaction.agreementNumber),
            React.createElement("h1", { className: "text-center text-blue-2" }, "Your account"),
            React.createElement("div", { className: "d-flex justify-content-center mr-5" },
                React.createElement("ul", { className: "font-family-display mb-0 pl-0" },
                    React.createElement("li", { className: "media mb-1" },
                        React.createElement("img", { className: "mt-1 mr-2", src: "/img/tick.svg", alt: "tick icon", tabIndex: 0, "aria-label": "Green tick icon" }),
                        React.createElement("div", { className: "media-body" },
                            React.createElement("p", { className: "mb-0" }, "View or edit your cover details"))),
                    React.createElement("li", { className: "media mb-1" },
                        React.createElement("img", { className: "mt-1 mr-2", src: "/img/tick.svg", alt: "tick icon", tabIndex: 0, "aria-label": "Green tick icon" }),
                        React.createElement("div", { className: "media-body" },
                            React.createElement("p", { className: "mb-0" }, "Download your documents"))),
                    React.createElement("li", { className: "media mb-1" },
                        React.createElement("img", { className: "mt-1 mr-2", src: "/img/tick.svg", alt: "tick icon", tabIndex: 0, "aria-label": "Green tick icon" }),
                        React.createElement("div", { className: "media-body" },
                            React.createElement("p", { className: "mb-0" }, "Change your payment date"))),
                    services_1.productHelper.isRenters(this.props.interaction) &&
                        React.createElement("li", { className: "media mb-1" },
                            React.createElement("img", { className: "mt-1 mr-2", src: "/img/tick.svg", alt: "tick icon", tabIndex: 0, "aria-label": "Green tick icon" }),
                            React.createElement("div", { className: "media-body" },
                                React.createElement("p", { className: "mb-0" }, "Add images / receipts of your high value items"))),
                    React.createElement("li", { className: "media mb-1" },
                        React.createElement("img", { className: "mt-1 mr-2", src: "/img/tick.svg", alt: "tick icon", "aria-label": "Green tick icon" }),
                        React.createElement("div", { className: "media-body" },
                            React.createElement("p", { className: "mb-0" }, "Cancel your subscription"))))),
            React.createElement("a", { className: "btn btn-primary btn-next btn-payment-success", role: "button", href: "/dashboard" }, "Go to your account")));
    };
    PaymentCompleteWidget.prototype.wordingToShow = function () {
        if (this.getSetting("showAllDoneText", false)) {
            if (!this.getSetting("noPaymentNeeded", false) && this.props.interaction.factors.additionalPremium && this.props.interaction.factors.additionalPremium > 0) {
                return "Payment complete";
            }
            else {
                return "All done";
            }
        }
        else {
            return "Payment complete";
        }
    };
    PaymentCompleteWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "showAllDoneText", type: journey_model_1.TypeDescriptions.Boolean },
            { name: "noPaymentNeeded", type: journey_model_1.TypeDescriptions.Boolean }
        ])
    ], PaymentCompleteWidget);
    return PaymentCompleteWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=PaymentCompleteWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/payments/PaymentCompleteWidget.js
// module id = 3454
// module chunks = 0